import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_inventory_adjustments_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { filters?: { material?: string, vendor_lot?: string, lot?: string, project?: string, owner?: string, license_plate?: string, location?: string, warehouse?: string, packaging?: string, completed_from?: string, completed_to?: string }, as_export?: boolean, paging?: { skip?: number, top?: number } }): Promise<{ paging?: { total_records?: number, skip?: number, top?: number, message?: string }, adjustments?: { owner?: string, project?: string, material?: string, packaging?: string, vendor_lot?: string, lot?: string, warehouse?: string, location?: string, license_plate?: string, serial_numbers?: string[], completed_on?: string, packaged_amount?: number }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

